﻿export default function () {
    const { $api } = useNuxtApp();
    const locationInfo = useStateLocationInfo();
    const regions = useStateRegionInfo();

    return computed<RegionInfo | null>({
        get: () =>
            (regions.value ? regions.value.find((c) => c.RegionId == locationInfo.value.RegionId) : null) ?? null,
        set: async (region: RegionInfo | null) => {
            if (!region) return;

            const body = new FormData();
            body.append("RegionId", region.RegionId.toString());
            // Use $api (not raw $fetch) for CSRF/header/lang parity with the sibling
            // locale composables. The full reload below is what keeps pricing consistent
            // with the new region, so we don't mutate locationInfo here.
            await $api("locale-service/SetRegion", { method: "POST", body });
            reloadNuxtApp({ force: true });
        },
    });
}
